// extracted by mini-css-extract-plugin
export default {"content":"DomainsPage_content__yxFq9","footer":"DomainsPage_footer__W95xX"};